// extracted by mini-css-extract-plugin
module.exports = {"border":"RecipeCard_border__pdzgu","borderRound":"RecipeCard_borderRound__MDcss"};